window.addEventListener('resize', () => {
  resizeVideo()
})

function resizeVideo() {
  const videos = document.querySelectorAll('.banner-main-video')
  videos.forEach(video => {
    if (!video) return

    const container = video.parentElement
    const containerRatio = container.offsetWidth / container.offsetHeight
    const videoRatio = video.videoWidth / video.videoHeight

    if (containerRatio < videoRatio) {
      video.style.width = 'auto'
      video.style.height = '100%'
    } else {
      video.style.height = 'auto'
      video.style.width = '100%'
    }
  })
}
